<script setup lang="ts">
import IconMenu from '@/components/icons/IconMenu.vue'
import AccountSidebar from '@/components/common/AccountSidebar.vue'
import type { SidebarEmits } from '@/shared/emits/sidebar.emit'
import { useClaroHeader } from '@/shared/composables/useClaroHeader'
import { useSidebar } from '@/shared/composables/useSidebar'
import SvgIcon from './SvgIcon.vue'
import { ESprites, ESpritesUI } from '@/shared/enum/sprites.enum'

const emit = defineEmits<SidebarEmits>()

const { isOpenSidebar, handleSidebarPosition } = useSidebar(emit)
const { msisdn, shouldShowSidebarToggle, shouldShowWelcomePhone, goToLandingPage } =
  useClaroHeader()
</script>

<template>
  <header class="grid content-center grid-cols-3 gap-2 p-3 bg-orangey-red justify-items-stretch">
    <svg-icon
      id="navbar-claro-logo"
      alt="Claro logo"
      data-testid="qa_navbar_claro_logo"
      width="5rem"
      height="1.75rem"
      class="flex-none text-white"
      itemprop="logo"
      :file="ESprites.UI"
      :name="ESpritesUI.CLARO"
      @click="goToLandingPage"
    />
    <div
      v-if="shouldShowWelcomePhone"
      id="navbar-welcome"
      data-testid="qa_navbar_welcome"
      class="flex flex-col text-xs text-center text-white cursor-default h-fit w-fit justify-self-center"
      itemprop="member"
      itemscope
      itemtype="http://schema.org/Person"
      @click="goToLandingPage"
    >
      <span id="navbar-welcome-text" itemprop="description"> Bienvenido </span>
      <span id="navbar-welcome-msisdn" itemprop="telephone">
        {{ msisdn }}
      </span>
    </div>
    <IconMenu
      v-if="shouldShowSidebarToggle"
      alt="Navbar Toggler"
      class="cursor-pointer w-7 h-7 justify-self-end"
      role="button"
      aria-label="Abrir menú lateral"
      @click="handleSidebarPosition"
    />
  </header>
  <transition name="sidenav-effect">
    <AccountSidebar v-if="isOpenSidebar" @change:sidebar-position="handleSidebarPosition" />
  </transition>
</template>

<style scoped>
.sidenav-effect-enter-to,
.sidenav-effect-enter-from,
.sidenav-effect-leave-from,
.sidenav-effect-leave-to {
  @apply transition-all ease-in-out duration-500 z-20;
}

.sidenav-effect-enter-from,
.sidenav-effect-leave-to {
  @apply -translate-x-full;
}

.navbar-center-container {
  @apply text-center text-xs text-white cursor-default flex flex-col h-fit w-fit;
}
.navbar-grid {
  @apply p-3 bg-orangey-red grid gap-2 content-center justify-items-stretch grid-cols-3;
}
</style>
